/*
 * @Author: Marte
 * @Date:   2017-10-25 19:45:05
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-10-25 20:13:32
 */

'use strict';
angular.module('myResourcesSearchModule', ['myResourcesSearchQuickPreviewModule'])
    .controller('myResourcesSearchCtrl', ['$scope', '$stateParams', 'trsHttpService', 'modalDialog', '$state', 'resCtrModalService', 'trsspliceString', 'trsPrintService', 'storageListenerService', function($scope, $stateParams, trsHttpService, modalDialog, $state, resCtrModalService, trsspliceString, trsPrintService, storageListenerService) {
        initStatus();
        initData();

        /** [initData description]初始化数据得操作 */
        function initData() {
            if (angular.isDefined($scope.$root.filterDataBack)) { // 判断是否有传递的数据
                var filterDataBack = angular.copy($scope.$root.filterDataBack);
                $scope.page = filterDataBack.page;
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                if (!!filterDataBack.content_keyword) {
                    $scope.params.content_keyword = $scope.data.keyword = filterDataBack.content_keyword; // 检索词
                }
                $scope.status.selectedSearch = filterDataBack.selectedSearch; // 检索类型
                $scope.params.search_type = $scope.status.selectedSearch.value;

                if (angular.isDefined(filterDataBack.fromdate) && filterDataBack.fromdate != '') { // 时间下拉选择
                    $scope.data.fromdate = angular.copy(filterDataBack.fromdate);
                    $scope.data.untildate = angular.copy(filterDataBack.untildate);
                    $scope.params.time = $scope.data.fromdate + ',' + $scope.data.untildate;
                }
                requestData();
            } else {
                $scope.status.selectedSearch = $scope.status.searchTypes[$stateParams.searchtype];
                requestData();
            }
            $scope.$on('$destroy', function() {
                delete $scope.$root.filterDataBack;
            });
        }

        /** [initStatus description] 初始化状态 */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1
            };
            $scope.data = {
                resourceList: [], // 获得到的总列表数据得数组
                keyword: $stateParams.searchword, // 初始化时候将检索的关键词复制给该页面的检索框
                selectManuList: [], // 被选中的稿件ID数组
                selectedManuItem: [], // 将选中的稿件详情压入该数组中用于以备用
            };
            $scope.status = {
                searchTypes: [ // 类型下拉框的初始化数据
                    { name: '全部', value: '0' },
                    { name: '标题', value: '1' },
                    { name: '媒体', value: '2' },
                    { name: '正文', value: '3' }
                ],
                selectedSearch: {}, // 被选中的下拉框选项
                indexName: ''
            };
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'subSearchAll',
                content_keyword: $stateParams.searchword,
                time: '-1'
            };
        }

        /** [requestData description]获取数据 */
        function requestData() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.params.pageSize = $scope.page.PAGESIZE;
            $scope.params.search_type = $scope.status.selectedSearch.value;
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                for (var i in data.content) {
                    data.content[i].DOCPUBTIME = new Date(data.content[i].DOCPUBTIME);
                }
                $scope.data.resourceList = data.content;
                storageListenerService.previewPageTurningStorage($scope.data.resourceList, 'ZB_GUID', 'resourceDetail');
                $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                $scope.status.indexName = data.summary_info.indexName;
                initOperFlag();
            });
        }

        /** [searchWithKeyword description] 检索信息 */
        $scope.searchWithKeyword = function() {
            $scope.params.content_keyword = $scope.data.keyword;
            requestData();
        };

        /** [searchByDate description] 日期检索后的回调 */
        $scope.searchByDate = function() {
            if ($scope.data.fromdate != '') {
                $scope.params.time = [$scope.data.fromdate, $scope.data.untildate].join(',');
            } else {
                $scope.params.time = '-1';
            }
            requestData();
        };

        /** [requestData description]跳转的分页管理 */
        $scope.requestData = function() {
            $scope.data.selectManuList = [];
            requestData();
        };

        /**
     * [selectManu description]选中单篇稿件的操作
     * @return {[type]} [description]item： 该稿件的信息对象参数
     */
        $scope.selectManu = function(item) {
            var num = $scope.data.selectManuList.indexOf(item.ZB_GUID);
            if (num > -1) {
                $scope.data.selectManuList.splice(num, 1);
                $scope.data.selectedManuItem.splice(num, 1);
            } else {
                $scope.data.selectManuList.push(item.ZB_GUID);
                $scope.data.selectedManuItem.push(item);
            }
        };

        /** [selectManuAll description] 多选的全选操作 */
        $scope.selectManuAll = function() {
            if ($scope.data.selectManuList.length === $scope.data.resourceList.length && $scope.data.resourceList.length > 0) {
                $scope.data.selectManuList = [];
                $scope.data.selectedManuItem = [];
            } else {
                $scope.data.selectManuList = [];
                $scope.data.selectedManuItem = [];
                for (var i = 0; i < $scope.data.resourceList.length; i++) {
                    $scope.data.selectManuList.push($scope.data.resourceList[i].ZB_GUID);
                    $scope.data.selectedManuItem.push($scope.data.resourceList[i]);
                }
            }
        };

        /** [collectSelcted description] 收藏选中的稿件 */
        $scope.collectSelcted = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: $scope.data.selectManuList.join(','),
                channelName: 'iwo',
                indexName: $scope.status.indexName
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /** [creationAxis description]将选中的额稿件将入个人素材 */
        $scope.creationAxis = function() {
            var params = {
                typeid: 'zyzx',
                PersonalMaterialId: 0,
                serviceid: 'mlf_bigdataexchange',
                methodname: 'batchPersonalMaterial',
                guid: $scope.data.selectManuList.join(','),
                channelName: 'iwo',
                indexName: $scope.status.indexName
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('', '选中稿件已成功加入个人素材!', 'success', false, function() {

                });
            });
        };

        /**
     * [goBack description] 返回订阅架的页面
     * @return {[type]} [description]
     */
        $scope.goBack = function() {
            $state.go('front.networksource.myresources.subscriptionfolder');
        };

        /**
     * [goToPreview description] 进入到快速预览页面
     * @return {[type]} [description]
     */
        $scope.goToPreview = function() {
            $scope.$root.filterData = {
                page: $scope.page, // 分页
                content_keyword: $scope.params.content_keyword, // 检索词
                selectedSearch: $scope.status.selectedSearch, // 检索类型
                fromdate: $scope.data.fromdate, // 开始时间
                untildate: $scope.data.untildate, // 结束时间
            };
            $state.go('front.networksource.myresources.searchquickpreview', { searchword: $scope.data.keyword, searchtype: $stateParams.searchtype, indexname: $scope.status.indexName });
        };

        /** [qugao description] 取稿操作*/
        $scope.takeDraft = function() {
            if ($scope.data.selectManuList.length > 0) {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'fetch',
                    guid: $scope.data.selectManuList.join(','),
                    channelName: 'iwo',
                    typeName: '73',
                    indexName: $scope.status.indexName
                };
                var modalInstance = resCtrModalService.fullTakeDraft(params, false, $scope.data.selectManuList);
                modalInstance.result.then(function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        $scope.data.selectManuList = [];
                        $scope.data.selectedManuItem = [];
                        requestData();
                    });
                }, function() {
                    $scope.data.selectManuList = [];
                    $scope.data.selectedManuItem = [];
                });
            } else {
                modalDialog.alertType('', '请先选择稿件!', 'warning', false);
            }
        };

        /**
     * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
     * [Reserve description] 预留
     */
        $scope.reserve = function() {
            if (!$scope.data.selectManuList.length) {
                modalDialog.alertType('请先选择稿件！', '', 'warning', false, '');
                return;
            }
            var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedManuItem);
            resCtrModalServiceModal.result.then(function(result) {
                delete result.items;
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'delay',
                    guid: trsspliceString.spliceString($scope.data.selectedManuItem, 'ZB_GUID', ','),
                    typeName: 73,
                    indexName: $scope.page.indexName,
                    channelName: 'iwo'
                };
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('预留成功!', '', 'success', false, function() {
                        $scope.data.selectManuList = [];
                        $scope.data.selectedManuItem = [];
                    }, function() {
                        $scope.data.selectManuList = [];
                        $scope.data.selectedManuItem = [];
                    });
                });
            });
        };

        /**
     * [print description] 打印
     * @return {[type]} [description]
     */
        $scope.print = function() {
            if ($scope.data.selectManuList.length === 0) {
                modalDialog.alertType('', '请先选中稿件!', 'warning', false);
                return;
            }
            var params = {
                'serviceid': 'iwo',
                'modelid': 'detailData',
                'guid': $scope.data.selectManuList.join(','),
                'channelName': 'iwo',
                'typeid': 'zyzx',
                'indexName': $scope.status.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                trsPrintService.trsPrintBigData(data);
                $scope.data.selectManuList = [];
                $scope.data.selectedManuItem = [];
            });
        };

        /**
     * [export description] 导出
     * @return {[type]} [description]
     */
        $scope.export = function() {
            if ($scope.data.selectManuList.length === 0) {
                modalDialog.alertType('', '请先选中稿件!', 'warning', false);
                return;
            }
            var params = {
                CHANNELNAMES: 'iwo',
                GUIDS: $scope.data.selectManuList.join(','),
                indexName: $scope.status.indexName,
                methodname: 'exportBigDataDocs',
                serviceid: 'mlf_exportword',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                $scope.data.selectManuList = [];
                $scope.data.selectedManuItem = [];
            });
        };

        /**
     * [initOperFlag description]初始化取签见重 1
     * @return {[type]} [description]
     */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.resourceList, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
        }

        /**
     * [showOperFlag description] 显示取签见撤重标志
     * @param  {[type]} guid      [description]
     * @param  {[type]} flagIndex [description]
     * @return {[type]}           [description]
     */
        $scope.showOperFlag = function(guid, flagIndex, flag) {
            var temp = queryItemBYGUID(guid, flag);
            if (!!temp) {
                return queryItemBYGUID(guid, flag).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
     * [viewBigDataInfo description]
     * @param  {[type]} ChnlDocId  [description]取签侧重的弹框展示
     * @param  {[type]} showRepeat [description]
     * @param  {[type]} showClick  [description]
     * @return {[type]}            [description]
     */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId, 'GUID').OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
     * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
     * @param  {[type]} guid [description]
     * @return {[type]}      [description]
     */
        function queryItemBYGUID(id, flag) {
            for (var i in $scope.data.operFlags) {
                if (id == $scope.data.operFlags[i][flag]) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * [openPageForSearch description] 打开高级检索新页面
         * @return {[date]} [description]
         */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };
    }]);
